import { Provider } from "react-redux";
import { store } from "./store/store";
import PageRoute from "./pages/PageRoute";
import { CookiesProvider } from "react-cookie";

function App() {
  
  return (
    <CookiesProvider>
      <Provider store={store}>
        <title>{process.env.REACT_APP_PAGE_TITLE}</title>
        <PageRoute />
      </Provider>
    </CookiesProvider>
  );
}

export default App;
